import { Fragment, useState } from 'react'
import { Button, Card, CardBody, CardFooter, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import Loader from 'react-loaders'
import { ReactComponent as AddIcon } from "../../../../../assets/utils/images/svgs/addBlue.svg"
import { ReactComponent as Delete } from "../../../../../assets/utils/images/svgs/DeleteBlue.svg"
import Algemeen from './Algemeen'
import Standaardkeuzes from './Standaardkeuzes'
import PageHeading from 'Layout/AppMain/PageHeading';
import TransitionOnLoad from "Components/TransitionOnLoad";
import ControleInstellingenPlanning from './ControleInstellingenPlanning';
import CentralePlanning from './CentralePlanning';
import Schoolplanning from './Schoolplanning';
import FiltersCentralePlanning from './FiltersCentralePlanning';
import FiltersSchoolplanning from './FiltersSchoolplanning';
import { useLocation, useNavigate } from 'react-router';
import ContractTypenService from 'Api/Instellingen/ContractTypen';
import ContractWijzigenToevoegenService from 'Api/Instellingen/ContractTypen/WijzigenToevoegen/index';
import { debounce } from '../../../../../helperFunctions/index';
import { toast } from 'react-toastify';
import useSWR from 'swr';
import { useApiMutation } from 'services/useApiMutation'
import { useContractFiltersList } from 'Api/Coordinator/Instellingen'

const WijzigenToevoegen = () => {
    const navigate = useNavigate();
    const [isDeleteModalOpen, setDeleteModalOpen] = useState(false);
    const [memoSavedValue, setMemoSavedValue] = useState("");
    const [errorField, setErrorField] = useState('');
    const location = useLocation();
    const { contractId, communityId } = location?.state;
    const { trigger: saveContractMutation } = useApiMutation();
    const { trigger: deleteContractMutation } = useApiMutation();
    const { trigger: filterSaveMutation } = useApiMutation();
    const { trigger: deleteFilterMutation } = useApiMutation();

    const contractKey = contractId
        ? ["contract-details", communityId, contractId]
        : null;

    const {
        data: contractResponse,
        isLoading: contractLoading,
        mutate: refreshContract,
    } = useSWR(
        contractKey,
        () =>
            ContractWijzigenToevoegenService.showContract({
                iCommunityId: communityId,
                contractId,
            }),
        {
            revalidateOnMount: true,
            revalidateOnFocus: false,
        }
    );

    const contractList =
        contractResponse?.data?.data || {};


    const callApi = (
        field,
        value,
        type,
        setFieldError,
        setLoadingKeys,
        setFieldValue
    ) => {
        if (value === "") {
            if (setFieldError) {
                setFieldError(field, "required");
            }

            toast.error("Dit veld is verplicht");
            return;
        }

        const requestData = {
            iCommunityId: communityId,
            contractId: contractId,
            ...(field ? { attr: field } : {}),
            [field]: value,
            ...(type ? { role: type } : {})
        };

        saveContractMutation(() =>
            ContractTypenService.saveContract(requestData)
        )
           .then(async (response) => {
             
                if (response?.status) {

                    // Memo: use the value returned by save API
                    if (field === "opmerking") {
                        const backendValue = response?.data?.opmerking ?? "";

                        if (setFieldValue) {
                            setFieldValue("Memo", backendValue, false);
                        }

                        return;
                    }

                    // All other fields: refresh GET API
                    await refreshContract();

                    return;
                }

                if (!response?.status) {
                    setErrorField(field);

                    const errors = response?.data?.[field];

                    if (Array.isArray(errors)) {
                        toast.error(errors.join(","));
                    } else {
                        const attr = response?.data?.attr || "";

                        if (
                            attr.includes("The value already exists for order") ||
                            attr.includes("The value already exists for m_order")
                        ) {
                            toast.dismiss();
                            toast.error(
                                "De waarde voor de volgorde bestaat al."
                            );
                        } else {
                            toast.dismiss();
                            toast.error(attr);
                        }
                    }
                }
            })
            .catch((error) => {
                console.error("API error:", error);
            })
            .finally(() => {
                if (setLoadingKeys) {
                    setLoadingKeys(prev => ({
                        ...prev,
                        [field]: false
                    }));
                }
            });
    };

    const debouncedApiCall = debounce(callApi, 500);

    const handleFieldChange = (
        field,
        value,
        type,
        setFieldError,
        setFieldValue
    ) => {
      
        setErrorField("");

        debouncedApiCall(
            field,
            value,
            type,
            setFieldError,
            undefined,
            setFieldValue
        );
    };
    const handleIconFieldChange = (field, value, type, setLoadingKeys) => {
        setErrorField('');
        callApi(field, value, type, null, setLoadingKeys);
    };


    const handleFilterDelete = (id) => {
        deleteFilterMutation(() =>
            ContractWijzigenToevoegenService.contractFilterDelete(id)
        )
            .then((response) => {
                if (response?.status) {
                    refreshFilters();
                }
            });
    };

    const {
        data: filterResponse,
        mutate: refreshFilters,
        isLoading: filterLoading,
    } = useContractFiltersList(communityId, contractId);

    const filterData = filterResponse?.data?.filters || {};

    if (!contractList) {
        return <Loader type="ball-grid-pulse" className={'mt-3 d-flex mx-auto justify-content-center'} />
    }


    const deleteContract = () => {
        const data = {
            iCommunityId: communityId,
            contractId,
        };

        deleteContractMutation(() =>
            ContractTypenService.deleteContract(data)
        )
            .then((response) => {
                if (response?.success) {
                    navigate('/c-instellingen/contracttypen', {
                        state: { forceRefetch: true }
                    });
                }
            })
            .catch((error) => {
                console.error('API error:', error);
            });
    };

    const filterSave = (role) => {
        const rolee = role === "school" ? "1" : "0";
        const data = {
            iCommunityId: communityId,
            iContractTypeId: contractId,
            role: rolee
        }
        filterSaveMutation(() => ContractWijzigenToevoegenService.contractFilterSave(data))
            .then((response) => {
    
                if (response?.status == true) {
                    refreshFilters();
                    return
                };
            })
            .catch((error) => {
                errorField.setFilterCentralePlanning(error.response?.data?.message);
            });
    }

    const showFilter = (role, filterId, planning) => {
        navigate(`/c-instellingen/contracttypen/filterinstellingen/${filterId}`, { state: { planning: planning, iCommunityId: communityId, filterId: filterId, role: role, contractName: contractResponse?.data?.data?.lists.abbr } });
    }

    return (
        <Fragment>
            <PageHeading
                useDefaultPath={false}
                additionalBreadcrumbs={[
                    {
                        label: "Instellingen",
                        href: "/#/c-instellingen/besturen"
                    },
                    {
                        label: "Contracttypen",
                        clickable: false
                    },
                    {
                        label: contractResponse?.data?.data?.lists.abbr || "Contracttype",
                        clickable: false
                    }
                ]}
            />
            <TransitionOnLoad>
                {
                    contractLoading || filterLoading ?
                        <Card className="main-card">
                            <CardBody className="d-flex flex-column">
                                <Loader type="ball-grid-pulse" className={'mt-3 d-flex mx-auto justify-content-center'} />
                            </CardBody>
                        </Card> : <>
                            <div className='row contract-typen-view mb-5'>
                                <div className='col-xl-6 col-xxl-4 p-2'>
                                    <Algemeen data={contractList} changeHandler={handleFieldChange} handleIconFieldChange={handleIconFieldChange} errorField={errorField} onMemoSaved={(value) => {
                                        setMemoSavedValue(value);
                                    }} />
                                </div>
                                <div className='col-xl-6 col-xxl-4 p-2'>
                                    <Standaardkeuzes data={contractList} changeHandler={handleFieldChange} errorField={errorField} />
                                </div>
                                <div className='col-xxl-4 p-2'>
                                    <ControleInstellingenPlanning data={contractList} handleIconFieldChange={handleIconFieldChange} />
                                </div>
                                <div className='col-xl-6 p-2'>
                                    <CentralePlanning data={contractList} handleIconFieldChange={handleIconFieldChange} changeHandler={handleFieldChange} />
                                </div>
                                <div className='col-xl-6 p-2'>
                                    <Schoolplanning data={contractList} handleIconFieldChange={handleIconFieldChange} changeHandler={handleFieldChange} />
                                </div>
                                <div className={`col-xl-6 p-2 ${!Number(contractList?.lists?.cp?.hidden) ? "d-block" : "d-none"}`}>
                                    <FiltersCentralePlanning fetchFilter={refreshFilters} filterData={filterData?.fcp} showFilter={showFilter} handleFilterDelete={handleFilterDelete} />
                                </div>
                                <div className={`col-xl-6 p-2 ${!Number(contractList?.lists?.sp?.m_hidden) ? "d-block" : "d-none"}`}>
                                    <FiltersSchoolplanning fetchFilter={refreshFilters} filterData={filterData?.fsp} showFilter={showFilter} handleFilterDelete={handleFilterDelete} />
                                </div>
                            </div>
                            <div className="chat-layout-footer py-5">
                                <CardFooter className="chat-layout-footer__inner gebruikers-footer">
                                    <div className="d-flex gap-3">

                                        <Button
                                            outline
                                            className="btn-outline-primary-blue d-flex justify-content-center align-items-center gap-2"
                                            onClick={() => { filterSave("central") }}
                                            type="button"
                                            color="primary"
                                            disabled={!contractList?.lists?.cp?.hidden ? false : true}
                                        >
                                            Centrale planning filter <AddIcon />
                                        </Button>
                                        <Button
                                            outline
                                            className="btn-outline-primary-blue d-flex justify-content-center align-items-center gap-2"
                                            onClick={() => { filterSave("school") }}
                                            type="button"
                                            color="primary"
                                            disabled={!contractList?.lists?.sp?.m_hidden ? false : true}
                                        >
                                            Schoolplanning filter  <AddIcon />
                                        </Button>
                                        <Button
                                            outline
                                            className="btn-outline-primary-blue d-flex justify-content-center align-items-center gap-2"
                                         
                                            onClick={() => setDeleteModalOpen(true)}
                                            type="button"
                                            color="primary"
                                            disabled={!contractList?.lists?.iFailOver ? false : true}
                                        >
                                            Contracttype  <Delete />
                                        </Button>
                                    </div>
                                </CardFooter>
                            </div>

                            <Modal isOpen={isDeleteModalOpen} className="modal-centered contract-type-modal feedback-modal-style link-form">
                                <ModalHeader toggle={() => setDeleteModalOpen(false)} className='px-3 mt-4'>Contracttype verwijderen</ModalHeader>

                                <ModalBody className='text-center mt-4 mb-4'>
                                    <p className="contracttype-Modal">Wilt u het geselecteerde contracttype verwijderen?</p>
                                </ModalBody>
                                <ModalFooter className='justify-content-center pt-3'>
                                    <>
                                        <Button color="link" onClick={() => { deleteContract() }} className={"btn-color-style"}>
                                            Ja
                                        </Button>
                                        <Button color="link" onClick={() => setDeleteModalOpen(false)} className={"btn-color-style"}>
                                            Nee
                                        </Button>
                                    </>
                                </ModalFooter>
                            </Modal>
                        </>
                }
            </TransitionOnLoad>

        </Fragment>
    )
}

export default WijzigenToevoegen